import { create } from 'zustand';

import { IProfileCompletionModalState } from './interfaces';

export const useProfileCompletionModalState =
  create<IProfileCompletionModalState>((set) => ({
    open: false,
    mode: 'required',
    openRequired: () => set({ open: true, mode: 'required' }),
    openEdit: () => set({ open: true, mode: 'edit' }),
    close: () => set({ open: false, mode: 'required' }),
  }));
